import { Outlet, Link, useNavigate } from 'react-router-dom'
import { LogOut } from 'lucide-react'
import { useAuth } from '../../hooks/useAuth'
import Button from '../ui/Button'

function DashboardLayout() {
  const { user, signOut } = useAuth()
  const navigate = useNavigate()

  const handleSignOut = async () => {
    await signOut()
    navigate('/')
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Dashboard Header */}
      <div className="bg-white border-b sticky top-0 z-50 shadow-sm">
        <div className="container-custom">
          <div className="flex items-center justify-between h-16">
            {/* Logo */}
            <Link to="/dashboard" className="flex items-center gap-3">
              <img
                src="/images/logos/logo-cy-rectangle.webp"
                alt="Cy Art Luthier"
                className="h-10 w-auto"
              />
            </Link>

            {/* Actions */}
            <div className="flex items-center gap-3">
              <div className="text-sm text-gray-600 hidden md:block">
                {user?.email}
              </div>
              <Button
                onClick={handleSignOut}
                variant="outline"
                size="sm"
                leftIcon={<LogOut className="h-4 w-4" />}
              >
                Déconnexion
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Page content */}
      <Outlet />
    </div>
  )
}

export default DashboardLayout
